import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import AiFieldComparison from "./AiFieldComparison";
import { AiFieldSuggestion } from "./types";

interface AiSuggestionReviewProps {
  labels: Record<string, string>;
  suggestions: AiFieldSuggestion[];
  warnings: string[];
  showCharacterCount?: boolean;
  guidance?: string;
  onChange: (fieldName: string, value: string) => void;
  onUseSuggestion: (suggestion: AiFieldSuggestion) => void;
  onKeepOriginal: (fieldName: string) => void;
  onUseAll: () => void;
  onCancel: () => void;
}

export default function AiSuggestionReview({
  labels,
  suggestions,
  warnings,
  showCharacterCount,
  guidance,
  onChange,
  onUseSuggestion,
  onKeepOriginal,
  onUseAll,
  onCancel,
}: AiSuggestionReviewProps) {
  return (
    <div className="ai-suggestion-review" role="region" aria-label="AI suggestion review">
      <div className="ai-suggestion-review__header">
        <div>
          <h3><AutoAwesomeIcon fontSize="small" /> Review AI suggestions</h3>
          <p>{guidance ?? "Check each suggestion before copying it into the form."}</p>
        </div>
        <button type="button" className="action-button" onClick={onUseAll}>Accept all</button>
      </div>
      {warnings.map((warning) => (
        <div className="notification notification--warning" key={warning}>{warning}</div>
      ))}
      <div className="ai-suggestion-review__fields">
        {suggestions.map((suggestion) => (
          <AiFieldComparison
            key={suggestion.fieldName}
            label={labels[suggestion.fieldName] ?? suggestion.fieldName}
            suggestion={suggestion}
            showCharacterCount={showCharacterCount}
            onChange={(value) => onChange(suggestion.fieldName, value)}
            onUseSuggestion={() => onUseSuggestion(suggestion)}
            onKeepOriginal={() => onKeepOriginal(suggestion.fieldName)}
          />
        ))}
      </div>
      <div className="ai-suggestion-review__footer">
        <span>Suggestions are not saved until you use the form's normal save action.</span>
        <button type="button" className="secondary-button" onClick={onCancel}>Cancel</button>
      </div>
    </div>
  );
}
